import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useGetStockCountQuery } from "@/redux/services/inventory/stockCount.api";
import StockCountEntryTable, {
  StockCountEntryTableSkeleton,
} from "@/components/inventory/stock-counts/StockCountEntryTable";

const StockCountDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useGetStockCountQuery({ uuid: id ?? "" }, {
    skip: !id,
  });

  if (!id) return null;

  return (
    <div className="space-y-4">
      <Link
        to="/inventory/stock-counts"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-card-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Retour aux inventaires
      </Link>
      {isLoading || !data ? (
        <StockCountEntryTableSkeleton />
      ) : (
        <StockCountEntryTable stockCount={data} />
      )}
    </div>
  );
};

export default StockCountDetailPage;
